import React from 'react'
import { speedometer } from 'components/assets.jsx.erb'

const Card = (props) => {
  const vehicle = props.vehicle;
  const vehicleName = vehicle.model_name + ", " + vehicle.make_name + ", " + vehicle.trim_name + ", " + vehicle.body_type
  const mileage = vehicle.mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  return (
    <div>
      <div className="float-box car-float-box">
        <div className="row">
          <div className="col-md-6">
            <img className="img-responsive" src={vehicle.vehicle_photo} alt="car" />
          </div>
          <div className="col-md-6">
            <div className="car-float-box-content">
              <h4 className="heading-car">{vehicle.heading}</h4>
              <br/>
              <p>
                <span className="mr">{speedometer}</span>
                {mileage}km indicated
              </p>
            </div>
          </div>
        </div>
        <hr/>
        <div className="car-float-box-content">
          <div className="flex-row space-between">
            <div>
              <strong>{vehicle.location_state}</strong>
            </div>
            <div>
              <strong>{vehicle.time_left}</strong>
              <a href={vehicle.url}>
                <button className="btn btn-blue-invert">Details</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Card;
